import React from "react"

function Target({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_10_321"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="8"
        y="8"
        width="20"
        height="20"
      >
        <path d="M28 8H8V28H28V8Z" fill="white" />
      </mask>
      <g mask="url(#mask0_10_321)">
        <path
          d="M21.3333 14.6665V12.1665L23.8333 9.6665L24.6667 11.3332L26.3333 12.1665L23.8333 14.6665H21.3333ZM21.3333 14.6665L18 17.9998M26.3333 17.9998C26.3333 22.6022 22.6023 26.3332 18 26.3332C13.3976 26.3332 9.66666 22.6022 9.66666 17.9998C9.66666 13.3975 13.3976 9.6665 18 9.6665M22.1667 17.9998C22.1667 20.301 20.3012 22.1665 18 22.1665C15.6988 22.1665 13.8333 20.301 13.8333 17.9998C13.8333 15.6987 15.6988 13.8332 18 13.8332"
          stroke="#003E4C"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
export default Target
